import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import secImg from "../../../../assets/img/sec.webp";
import blockchain from "../../../../assets/img/blockchain.webp";
import simplisity from "../../../../assets/img/simplisity.webp";

import "swiper/css/navigation";
import "swiper/swiper.min.css";
import "./Overview.css";

export const Overview = ({ data }) => {
  const swiperRef = useRef(null);

  const aboutProjectsData = [
    {
      id: 1,
      title: "Seamless Integration",
      description:
        "HyperPay offers a seamless integration process, allowing you to quickly add cryptocurrency payment options to your app without the need for extensive coding knowledge. With easy-to-follow documentation and developer-friendly tools, you can integrate crypto payments within minutes, providing your users with more flexible payment options.",
      image: simplisity,
    },
    {
      id: 2,
      title: "Advanced Security",
      description:
        "HyperPay prioritizes the security of your transactions with advanced encryption protocols. By using HyperPay, you can ensure that payments are processed securely, minimizing the risk of fraud and safeguarding your users' financial information.",
      image: secImg,
    },
    {
      id: 3,
      title: "Respecting Blockchain Fundamentals",
      description:
        "HyperPay respects blockchain fundamentals by offering a module that facilitates direct, transparent payments through smart contracts. By eliminating intermediaries, HyperPay ensures transactions are secure and efficient, staying true to the core principles of blockchain technology.",
      image: blockchain,
    },
  ];
  return (
    <div className="aboutContainer">
      <svg
        className="aboutCirclular-bg"
        width="435"
        height="538"
        viewBox="0 0 435 538"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle opacity="0.1" cx="269" cy="269" r="268.5" stroke="white" />
      </svg>
      <svg
        width="362"
        height="846"
        viewBox="0 0 362 846"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="aboutCirclular-bg-2"
      >
        <circle opacity="0.1" cx="-61" cy="423" r="422.5" stroke="white" />
      </svg>
      <div className="aboutWrapper">
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          loop={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          modules={[Navigation]}
        >
          {aboutProjectsData.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="aboutContent" key={index}>
                <div className="aboutImgWrapper">
                  <img
                    className="aboutImg fade-up"
                    src={item.image}
                    alt={" "}
                  />
                </div>
                <div className="aboutInfo">
                  <h2 className="aboutTitle fade-up">{item.title}</h2>
                  <p className="aboutText fade-up">{item.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div
            className="swiper-button-prev"
            onClick={() => swiperRef.current?.slidePrev()}
          ></div>
          <div
            className="swiper-button-next"
            onClick={() => swiperRef.current?.slideNext()}
          ></div>
        </Swiper>
      </div>
    </div>
  );
};
